'use strict';

var dashboardTasksCtrl = ['$state','toast', function($state,toast) {
    var _this = this;
    this.$state = $state;
    this.currentDate = $state.params.date ? new Date($state.params.date) : new Date();
    this.datePopup = false;
    this.dateOptions = {
        showWeeks: false
    };

    this.goToDate = function() {
        if (!this.currentDate) {
            return;
        }
        $state.go('dashboard.departments.department.tasks', {
            date: this.currentDate
        });
    };

    function shouldTaskAppearToday(task, selectedDate) {
        var checkDate = new Date(selectedDate);
        checkDate.setHours(23);
        checkDate.setMinutes(59);
        checkDate.setSeconds(59);
        var startDate = new Date(task.startDate);
        if (!task.repeatData)
            task.repeatData = {}
        var endRepeat = task.repeatData.repeatEnds ? new Date(task.repeatData.repeatTill) : null;

        // we set the endrepeat to last moment of the day
        if (endRepeat) {
            endRepeat.setHours(23);
            endRepeat.setMinutes(59);
            endRepeat.setSeconds(59);
        }

        var weekDays = {
            0: 'sunday',
            1: 'monday',
            2: 'tuesday',
            3: 'wednesday',
            4: 'thursday',
            5: 'friday',
            6: 'saturday'
        };

        //if task is not marked as repeat, show it...because it was filtered by the api
        if (!task.repeat) {
            return true;
        }

        var daysDiff = Math.floor((checkDate - startDate) / (1000 * 60 * 60 * 24));

        //dont show if it repeats but we are viewing a previous than creation date
        if (daysDiff < 0) {
            return false;
        }

        //if repeat ends, we check if we should show it...
        if (endRepeat && (endRepeat - checkDate) < 0) {
            return false;
        }


        if (task.repeatData.repeatType === 'daily') {
            var diff = daysDiff % task.repeatData.repeatEvery;
            //if the diff between days passed and repeat every is exact, we know we have to show the task.
            if (!diff) {
                return true;
            }
            return false;
        }

        if (task.repeatData.repeatType === 'weekly') {
            var weekDay = checkDate.getDay();
            //we check to see if selectedDate week day is true or false...
            if (task.repeatData.repeatWeekDays[weekDays[weekDay]]) {
                return true;
            }
            return false;
        }
    }


    //calculate time according to click position on the timeline
    function calculateTime(parentWidth, leftPosition) {
        var hourWidth = parentWidth / 24;
        var clickedHour = leftPosition / hourWidth;

        return Math.floor(clickedHour);
    }

    function getMinutes(time) {

        var hours = time.getHours();
        var minutes = time.getMinutes();

        var timeInMinutes = (hours * 60) + minutes;

        return timeInMinutes;
    }

    function calculateStyles(task) {
        var start;
        var end;
        var randomColor;
        var duration;
        var marginLeft;

        //if task is marked as allDay we skip everything and add this style
        if (task.allDay) {
            task.widthStyle = {
                width: 100 + '%',
                left: 0 + '%'
            };

            task.label = task.name;
            return;
        }

        //get random color for task bar
        randomColor = '#' + ((1 << 24) * Math.random() | 0).toString(16);

        //we get minutes to compare
        start = getMinutes(new Date(task.startDate));
        end = getMinutes(new Date(task.endDate));
        duration = end - start; //we get the duration of the task in minutes

        //we get the proportional length in % for the task according to its duration
        marginLeft = start * 100 / (60 * 24); //at what hour?
        duration = duration * 100 / (60 * 24); //for how long?

        task.widthStyle = {
            width: duration + '%',
            left: marginLeft + '%',
            backgroundColor: task.color || randomColor
        };
        task.label = task.name + ' | ' + ('0' + new Date(task.startDate).getHours()).slice(-2) + ':' + ('0' + new Date(task.startDate).getMinutes()).slice(-2) + '-' + ('0' + new Date(task.endDate).getHours()).slice(-2) + ':' + ('0' + new Date(task.endDate).getMinutes()).slice(-2) ;
    }

    function sortTask(tasks) {
        //we first exclude tasks that last all day...
        //this is gonna change if I change how to represent date and time.
        var allDay = tasks.filter(function(task) {
            return task.allDay;
        });
        //create array with the tasks which have start and end time.
        tasks = tasks.filter(function(task) {
            return !task.allDay;
        });

        //sort tasks from earliest to latest
        tasks.sort(function(a, b) {
            return getMinutes(new Date(a.startDate)) - getMinutes(new Date(b.startDate));
        });

        //here we group the tasks in arrays according to their graphical representation.
        //If they overlap, the second one is sent to the next array(row),etc...
        tasks = tasks.reduce(function(list, task) {
            if (!list.length) {
                list.push([task]);
                return list;
            }

            var locationIndex = 0;
            //we use for because we need the break...
            for (var i = 0; i < list.length; i++) {
                if (getMinutes(new Date(list[i][list[i].length - 1].endDate)) <= getMinutes(new Date(task.startDate))) {
                    locationIndex = i;
                    break;
                } else {
                    locationIndex++;
                }
            }

            if (!list[locationIndex]) {
                list[locationIndex] = [];
            }
            list[locationIndex].push(task);
            return list;

        }, []);

        if (allDay.length) {
            allDay = allDay.reduce(function(list, task) {
                list.push([task]);
                return list;
            }, []);
            return allDay.concat(tasks);
        } else {
            return tasks;
        }
    }

    this.tasks.forEach(function(member) {
        if (!member.task) {
            return;
        }

        //we check if the task should appear because of repeat data
        member.task = member.task.filter(function(task) {
            return shouldTaskAppearToday(task, _this.currentDate);
        });

        member.task.forEach(function(task) {
            calculateStyles(task);
        });
        member.task = sortTask(member.task);
    });


    this.goTo = function(type) {
        var next;
        var day = 1000 * 60 * 60 * 24;
        if (type === 'prev') {
            next = new Date(_this.currentDate.getTime() - day);
            return $state.go('dashboard.departments.department.tasks', {
                date: next
            });
        }
        if (type === 'next') {
            next = new Date(_this.currentDate.getTime() + day);
            return $state.go('dashboard.departments.department.tasks', {
                date: next
            });
        }
    };

    // checking this out
    this.checkClick = function(event, member) {
        var parentWidth = event.path.filter(function(node) {
            if (node.classList) {
                return node.classList.contains('calendar-body--user--tasks');
            }
        })[0].offsetWidth;

        var left = event.offsetX;
        var taskData = {
            time: calculateTime(parentWidth, left),
            date: this.currentDate,
            member: member
        };
    };
    _this.showToast=function(msg){
        toast.error(msg);
    }
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            tasks: '='
        },
        controller: dashboardTasksCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-tasks/dashboardTasksDirective.html'
    };
};
